var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8167C0 5.29383 4.47715 0.816681 10 0.816681H39C44.5228 0.816681 49 5.29383 49 10.8167V39.8167C49 45.3395 44.5228 49.8167 39 49.8167H10C4.47715 49.8167 0 45.3395 0 39.8167V10.8167Z",
    fill: "#3754DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3792 35.7702C28.3792 36.5122 29.3416 36.8036 29.7532 36.1862L37.9463 23.8966C38.2786 23.3982 37.9213 22.7306 37.3222 22.7306H30.9653V14.8632C30.9653 14.1212 30.0029 13.8298 29.5913 14.4472L21.3982 26.7368C21.0659 27.2352 21.4232 27.9028 22.0222 27.9028H28.3792V35.7702Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8625 17.7653C12.8625 16.9369 13.5341 16.2653 14.3625 16.2653H21.7069C22.5354 16.2653 23.2069 16.9369 23.2069 17.7653V18.6445C23.2069 19.4729 22.5354 20.1445 21.7069 20.1445H14.3625C13.5341 20.1445 12.8625 19.4729 12.8625 18.6445V17.7653ZM12.8625 33.282C12.8625 32.4535 13.5341 31.782 14.3625 31.782H21.7069C22.5354 31.782 23.2069 32.4535 23.2069 33.282V34.1611C23.2069 34.9895 22.5354 35.6611 21.7069 35.6611H14.3625C13.5341 35.6611 12.8625 34.9895 12.8625 34.1611V33.282ZM11.7764 24.0236C10.9479 24.0236 10.2764 24.6952 10.2764 25.5236V26.4028C10.2764 27.2312 10.9479 27.9028 11.7764 27.9028H17.8278C18.6562 27.9028 19.3278 27.2312 19.3278 26.4028V25.5236C19.3278 24.6952 18.6562 24.0236 17.8278 24.0236H11.7764Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.7e4e1ab295111ecb2d6e735c3bf45eb9.svg";
export { ForwardRef as ReactComponent };